import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-xl modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "error" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "error" }
const _hoisted_12 = { class: "modal-footer" }
const _hoisted_13 = ["disabled"]

import { ref, computed } from 'vue'

    import { ScoringSurveyEmailSenderViewModel } from '@Evaluation/AlternativesSurveys/Components/ScoringSurveyEmailSender'

    /* ---------------- props / emits ---------------- */

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ScoringSurveyEmailSender',
  props: {
    viewModel: {}
  },
  emits: ["send-email"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    /* ---------------- shortcuts ---------------- */

    const vm = computed(() => props.viewModel)
    const opened = computed(() => vm.value?.opened ?? false)

    /* ---------------- local state ---------------- */

    const EmailSubject = ref<string>('Please complete this survey')
    const EmailBody = ref<string>('Please click on the following link to complete your survey: {url}')

    /* ---------------- derived ---------------- */

    const numberOfEmailRecipients = computed(
        () => vm.value.projectUserIds.length
    )

    const emailBodyError = computed<string | null>(() =>
        EmailBody.value.indexOf('{url}') === -1
            ? '{url} is required in the message.'
            : null
    )

    const hasErrors = computed(() => emailBodyError.value != null)

    /* ---------------- actions ---------------- */

    function handleSendEmail()
    {
        emit('send-email', EmailSubject.value, EmailBody.value)
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h5", _hoisted_6, "Send email (" + _toDisplayString(numberOfEmailRecipients.value) + ")", 1 /* TEXT */),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("form", {
                  id: "scoring-survey-email-sender-form",
                  onSubmit: _withModifiers(handleSendEmail, ["prevent"])
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[2] || (_cache[2] = _createElementVNode("label", null, "Subject:", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((EmailSubject).value = $event)),
                      required: ""
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _vModelText,
                        EmailSubject.value,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.emailSubjectError), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _withDirectives(_createElementVNode("textarea", {
                      rows: "5",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((EmailBody).value = $event)),
                      required: ""
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _vModelText,
                        EmailBody.value,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createElementVNode("div", _hoisted_11, _toDisplayString(emailBodyError.value), 1 /* TEXT */)
                  ])
                ], 32 /* NEED_HYDRATION */)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "btn btn-outline-secondary"
                }, "Close"),
                _createElementVNode("button", {
                  type: "submit",
                  form: "scoring-survey-email-sender-form",
                  disabled: hasErrors.value,
                  class: "btn btn-primary"
                }, "Send email", 8 /* PROPS */, _hoisted_13)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})